export default __webpack_public_path__ + "../images/news-tile-2.jpg";